import { Component, h, Prop } from '@stencil/core';
import logout from '../../services/logout';

@Component({
  tag: 'header-nav',
  styleUrl: 'header-nav.scss',
  shadow: true,
})
export class headerNav {
  /**
   * The dev env
   */
  @Prop() env?: string = 'https://www.brighttalk.com';

  // This will add a redirect param to the end of the login url
  @Prop() loginRedirect?: string = '/login';

  // User State
  @Prop() isLoggedIn: boolean = false;
  @Prop() isManager: boolean = false;
  @Prop() isChannelOwner: boolean = false;
  @Prop() isPreAuthenticated: boolean = false;

  // Show/Hide Elements
  @Prop() join?: boolean = true;



  async logoutBtn(e) {
    e.preventDefault();
    await logout(this.env);
  }

  myAccount() {
    return (
      <ul id="menu-header" class="btalk-nav">
        <li class="menu-item">
          <a href={this.env +`/summits/`}>Summits</a>
        </li>

        <li class="menu-item menu-item-has-children">
          <a href={this.env +`/all-talks/`}>Communities <span class="fa-solid fa-angle-down" aria-hidden="true"></span></a>
          <ul class="sub-menu">
            <li>
              <a class="menu-item" href={this.env +`/all-talks/`}>
                All BrightTALK
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/business-management/`}>
                Business Management
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/finance/`}>
                Finance
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/human-resources/`}>
                Human Resources
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/information-technology/`}>
                Information Technology
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/legal/`}>
                Legal
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/marketing/`}>
                Marketing
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/research-and-development/`}>
                Research &amp; Development
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/sales/`}>
                Sales
              </a>
            </li>
          </ul>
        </li>

        <li class="my-account menu-item menu-item-has-children">
          <a href="#" rel="nofollow">
            <span>My account </span>
            <span class="icon far fa-angle-down" aria-hidden="true"></span>
          </a>
          <ul class="sub-menu">
            {this.isChannelOwner || this.isManager ? (
              <li class="menu-item">
                <a class="menu-item" href={this.env + `/central/manage/channels/`}>
                  Manage
                </a>
              </li>
            ) : (
              ''
            )}
            {this.isManager ? (
              <li class="menu-item">
                <a class="menu-item" href={this.env + `/central/`}>
                  BrightTALK Central
                </a>
              </li>
            ) : (
              ''
            )}
            <li class="menu-item">
              <a class="menu-item" href={this.env +`/mybrighttalk/my-feed/`}>
                My feed
              </a>
            </li>
            <li class="menu-item">
              <a class="menu-item" href={this.env +`/mybrighttalk/watch-later/`}>
                Watch later
              </a>
            </li>
            <li class="menu-item">
              <a class="menu-item" href={this.env +`/mybrighttalk/recently-viewed/`}>
                Recently viewed
              </a>
            </li>
            <li class="menu-item">
              <a class="menu-item" href={this.env +`/mybrighttalk/channels/`}>
                My channels
              </a>
            </li>
            <li class="menu-item">
              <a class="menu-item" href={this.env +`/mybrighttalk/settings/profile/`}>
                Account settings
              </a>
            </li>
            <li class="menu-item">
              <a class="menu-item" href="/logout" onClick={e => this.logoutBtn(e)}>
                Log out
              </a>
            </li>
          </ul>
        </li>
      </ul>
    );
  }

  loginJoin() {
    return (
      <ul id="menu-header" class="btalk-nav">
        <li class="menu-item">
          <a href={this.env +`/summits/`}>Summits</a>
        </li>

        <li class="menu-item menu-item-has-children">
          <a href={this.env +`/all-talks/`}>Communities <span class="fa-regular fa-angle-down" aria-hidden="true"></span></a>
          <ul class="sub-menu">
            <li>
              <a class="menu-item" href={this.env +`/all-talks/`}>
                All BrightTALK
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/business-management/`}>
                Business Management
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/finance/`}>
                Finance
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/human-resources/`}>
                Human Resources
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/information-technology/`}>
                Information Technology
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/legal/`}>
                Legal
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/marketing/`}>
                Marketing
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/research-and-development/`}>
                Research &amp; Development
              </a>
            </li>
            <li>
              <a class="menu-item" href={this.env +`/communities/sales/`}>
                Sales
              </a>
            </li>
          </ul>
        </li>

        <li class="menu-item">
          <a class="" href={this.env + this.loginRedirect} rel="nofollow">
            Log in
          </a>
        </li>
		{this.join ? <li class="menu-item btl-out btl-join btalk-join">
          <a class="" href={this.env + `/join`}>
            <span>Join now</span>
          </a>
        </li> : ''}
      </ul>
    );
  }

  render() {
    return <nav class="btalk-nav-wrap desktop">{this.isLoggedIn ? this.myAccount() : this.loginJoin()}</nav>;
  }
}
